import { FaPlusCircle } from "react-icons/fa";
import { FcPicture } from "react-icons/fc";
import { createPortal } from "react-dom";
import InternalTransaction from "../Transaction/InternalTransaction";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
export default function ReportWallet({ walletId }) {
  let type = "modal";

  return (
    <div
      className="modal fade"
      id="ReportWallet"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{ justifyContent: "end" }}>
            <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
              گزارش ولت{" "}
            </h5>
            <button
              type="button"
              className="btn btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body modlatrashposition">
            <InternalTransaction
              walletId={walletId}
              type={type}
            ></InternalTransaction>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
